import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ConsentToAccessService } from '../../../module/consent-to-access/consent-to-access.service';
declare const bootstrap: any;
interface LoginMethod {
  title: string;
  id: string;
  selected: boolean;
}
interface inputDetail {
  id: string;
  title: string;
}
interface LoginRole {
  title: string;
  id: string;
  selected: boolean;
  loginBy: LoginMethod[];
  forgetPassword: inputDetail
}
@Component({
  selector: 'login-modal',
  templateUrl: './login-modal.component.html',
  styleUrl: './login-modal.component.scss'
})
export class LoginModalComponent {
  loginModal: any;
  forgotPasswordModal: any;
  OTPModal: any;
  passwordModal: any;
  registerModal: any;
  formValidated: boolean = false;
  clientlogo = 'assets/images/logo/Logo.png';
  loginForms: { [key: string]: FormGroup } = {};
  forgotPasswordForms: { [key: string]: FormGroup } = {};
  OTPForms: { [key: string]: FormGroup } = {};
  passwordForms: { [key: string]: FormGroup } = {};
  loginRole: LoginRole[] = [{
    title: 'Citizen',
    id: 'citizen',
    selected: true,
    forgetPassword: {
      id: 'aadhar_number',
      title: 'Aadhar Number'
    },
    loginBy: [{
      title: 'Maha ID',
      id: 'maha_id',
      selected: true
    }, {
      title: 'Aadhar Number',
      id: 'aadhar_number',
      selected: false
    }]
  }, {
    title: 'Department',
    id: 'department',
    selected: false,
    forgetPassword: {
      id: 'email',
      title: 'Email'
    },
    loginBy: [{
      title: 'Usename',
      id: 'username',
      selected: true
    }]
  }, {
    title: 'VLE',
    id: 'vle',
    selected: false,
    forgetPassword: {
      id: 'email',
      title: 'Email'
    },
    loginBy: [{
      title: 'Usename',
      id: 'username',
      selected: true
    }]
  }];

  constructor(private router: Router, private fb: FormBuilder, private consentDataAcess: ConsentToAccessService) { }

  ngOnInit(): void {
    this.loginRole.forEach(role => {
      this.loginForms[role.id] = this.createLoginForm(role);
    });
    // Login Modal
    this.loginModal = new bootstrap.Modal(document.getElementById('loginModal'), { backdrop: 'static', focus: true, keyboard: false });
    this.loginModal._element.addEventListener('hide.bs.modal', () => { });
    this.loginModal._element.addEventListener('hidden.bs.modal', () => {
      if (this.formValidated) {
        this.formValidated = false;
        this.loginForms = {};
        switch (this.selectedRole) {
          case 'citizen':
            console.log('Submitting Citizen Login Form');
            this.router.navigate(['/consent-to-access']);
            break;
          case 'department':
            console.log('Submitting Department Login Form');
            break;
          case 'vle':
            console.log('Submitting VLE Login Form');
            break;
          default:
            console.log('Unknown role ID:', this.selectedRole);
            break;
        }
      }

    });
    this.loginModal._element.addEventListener('show.bs.modal', () => { });
    this.loginModal._element.addEventListener('shown.bs.modal', () => { });


    // Forgot Password Modal
    this.forgotPasswordModal = new bootstrap.Modal(document.getElementById('forgotPasswordModal'), { backdrop: 'static', focus: true, keyboard: false });
    this.forgotPasswordModal._element.addEventListener('hide.bs.modal', () => {
    });
    this.forgotPasswordModal._element.addEventListener('show.bs.modal', () => {
      this.loginModal.hide();
      this.loginRole.forEach(role => {
        this.forgotPasswordForms[role.id] = this.createForgotPasswordForm(role);
      });
    });
    this.forgotPasswordModal._element.addEventListener('shown.bs.modal', () => {

    });

    // OTP Modal
    this.OTPModal = new bootstrap.Modal(document.getElementById('OTPModal'), { backdrop: 'static', focus: true, keyboard: false });
    this.OTPModal._element.addEventListener('hide.bs.modal', () => {
    });
    this.OTPModal._element.addEventListener('show.bs.modal', () => {
      this.loginModal.hide();
      this.loginRole.forEach(role => {
        this.OTPForms[role.id] = this.createOTPForm(role);
      });
    });
    this.OTPModal._element.addEventListener('shown.bs.modal', () => {

    });
    // Password Modal
    this.passwordModal = new bootstrap.Modal(document.getElementById('passwordModal'), { backdrop: 'static', focus: true, keyboard: false });
    this.passwordModal._element.addEventListener('hide.bs.modal', () => {
    });
    this.passwordModal._element.addEventListener('show.bs.modal', () => {
      this.loginModal.hide();
      this.loginRole.forEach(role => {
        this.passwordForms[role.id] = this.createPasswordForm(role);
      });
    });
    this.passwordModal._element.addEventListener('shown.bs.modal', () => {

    });

    // Remove It If Not Needed
    this.consentDataAcess.loginListenerMsg$.subscribe((data: any) => {
      this.openModal();
    })
  }
  ngOnDestroy(): void {
    this.loginModal.dispose();
  }
  openModal(): void {
    this.loginModal.show();
  }
  closeModal(): void {
    this.loginModal.hide();
  }
  createLoginForm(role: LoginRole): FormGroup {
    const formControls: { [key: string]: FormControl } = {};
    role.loginBy.forEach(method => {
      if (method.selected) {
        formControls[method.id] = new FormControl('', this.getValidators(method.id));
      }
    });
    formControls['password'] = new FormControl('', Validators.required);
    return this.fb.group(formControls);
  }
  createForgotPasswordForm(role: LoginRole): FormGroup {
    const formControls: { [key: string]: FormControl } = {};
    const t = role.forgetPassword.id;
    formControls[t] = new FormControl('', this.getValidators(t));
    return this.fb.group(formControls);
  }
  createOTPForm(role: LoginRole): FormGroup {
    const formControls: { [key: string]: FormControl } = {};
    const t = role.forgetPassword.id;
    formControls[t + '_OTP'] = new FormControl('', Validators.required);
    return this.fb.group(formControls);
  }
  createPasswordForm(role: LoginRole): FormGroup {
    const formControls: { [key: string]: FormControl } = {};
    formControls['password_new'] = new FormControl('', Validators.required);
    formControls['password_confirm'] = new FormControl('', Validators.required);
    return this.fb.group(formControls);
  }
  selectedRole: string = 'citizen';
  toggleForm(roleId: string): void {
    this.loginRole.forEach(role => {
      role.selected = role.id === roleId;
      if (role.id === roleId) {
        this.selectedRole = roleId;
      }
    });
  }
  toggleLoginBy(roleId: string, methodId: string): void {
    this.loginRole.forEach(role => {
      if (role.id === roleId) {
        role.loginBy.forEach(method => {
          method.selected = method.id === methodId;
        });
        this.loginForms[role.id] = this.createLoginForm(role);
      }
    });
  }
  submitLoginForm(data: any): void {
    let value = data.value;

    let formDetails = {
      MahaID: value.maha_id,
      Password: value.password,
      Consent: "",
      Ip: "192.175.0.0",
      Time: ''
    };

    this.consentDataAcess.isLoggedIn = true;
    this.consentDataAcess.ActiveUserData(formDetails);

    this.loginModal.hide();
    this.formValidated = true;
  }
  submitforgetPasswordForm(): void {
    this.forgotPasswordModal.hide();
    this.OTPModal.show();
    switch (this.selectedRole) {
      case 'citizen':
        // Handle Citizen login form submission
        console.log('Submitting Citizen Login Form');
        break;
      case 'department':
        // Handle Department login form submission
        console.log('Submitting Department Login Form');
        break;
      case 'vle':
        // Handle VLE login form submission
        console.log('Submitting VLE Login Form');
        break;
      default:
        console.log('Unknown role ID:', this.selectedRole);
        break;
    }
  }
  submitOTPForm(): void {
    this.OTPModal.hide();
    this.passwordModal.show();
    switch (this.selectedRole) {
      case 'citizen':
        // Handle Citizen login form submission
        console.log('Submitting Citizen Login OTP Form');
        break;
      case 'department':
        // Handle Department login form submission
        console.log('Submitting Department Login OTP Form');
        break;
      case 'vle':
        // Handle VLE login form submission
        console.log('Submitting VLE Login OTP Form');
        break;
      default:
        console.log('Unknown role ID:', this.selectedRole);
        break;
    }
  }
  submitPasswordForm(): void {
    switch (this.selectedRole) {
      case 'citizen':
        // Handle Citizen login form submission
        console.log('Submitting Citizen Login OTP Form');
        break;
      case 'department':
        // Handle Department login form submission
        console.log('Submitting Department Login OTP Form');
        break;
      case 'vle':
        // Handle VLE login form submission
        console.log('Submitting VLE Login OTP Form');
        break;
      default:
        console.log('Unknown role ID:', this.selectedRole);
        break;
    }
  }
  getValidators(methodId: string): ValidatorFn[] {
    switch (methodId) {
      case 'aadhar_number':
        return [Validators.required, Validators.pattern('\\d{12}'), Validators.minLength(12), Validators.maxLength(12)];
      case 'email':
        return [Validators.required, Validators.email];
      case 'mobile':
        return [Validators.required, Validators.pattern('\\d{10}'), Validators.minLength(10), Validators.maxLength(10)];
      default:
        return [Validators.required];
    }
  }
}
